import React from 'react';
import { IconsPros } from '../icons/types';

/**
 * Speak2Leads Logo component
 *
 * @returns JSX.ELEMENT
 */
export const Speak2LeadsLogo = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 86.37 86.89" data-testid={dataTestId}>
      <rect fill="#fff" x="12.31" y="8.97" width="62.67" height="68.33" />
      <path
        fill="#04aef1"
        d="M4.56,29.34C4.06,24.08,3.7,18.81,3,13.58c-.38-2.78.54-3.69,3.21-4C26.31,7.48,46.41,5.24,66.52,3c3.81-.42,7.32-.81,11.41-1.36,2.68-.37,3.45.5,3.72,3C84,27,86.55,49.35,88.92,71.7c.9,8.43.75,8.37-7.86,9.31C59,83.4,36.9,85.81,14.84,88.37c-2.7.32-3.58-.07-3.9-3M46.1,63.81c2-3,3.53-5.32,5.07-7.56,4.2-6.1,8.61-12.11,10.66-19.37,3.74-13.23-5-24.12-18.7-23.45-11.06.54-20.47,11.14-19,21.29.49,3.25,2,5.43,5.49,5.7s5.36-1.61,6.07-4.9a45.31,45.31,0,0,1,1.58-6.14,5.89,5.89,0,0,1,6.57-4c3.27.37,5.12,2.56,5.54,5.83.4,3-.68,5.73-2.09,8.33-3.9,7.24-8.72,13.88-13.42,20.61a80.78,80.78,0,0,0-5.45,8.27c-2.09,4,.09,8,4.42,7.87a266.84,266.84,0,0,0,31.53-3.32c3.87-.58,5.49-4.69,3.6-8-1.62-2.86-4.37-3.07-7.28-2.74C56.19,62.71,51.63,63.2,46.1,63.81Z"
        transform="translate(-2.91 -1.58)"
      />
    </svg>
  );
};
